import { IModelInfo } from "services/SandboxIModels";
import { imodelSelected } from "store/features";
import { useAppSelector } from "store/hooks";
import { store } from "store/reduxStore";
import { HeaderButton, MenuItem, Text } from "@itwin/itwinui-react";
import styles from "./ImodelSelector.module.css";

export const IModelSelector = () => {
  const allowedImodels = useAppSelector((state) => state.activeSandbox.allowedImodels);
  const selectedImodel = useAppSelector((state) => state.activeSandbox.selectedImodel);

  if (!selectedImodel)
    return null;

  return (
    <>
      <Text isMuted={true} className={styles.label}>Selected iModel:</Text>
      <HeaderButton
        menuItems={allowedImodels && allowedImodels.length ? buildMenu(allowedImodels) : () => []}
        name={selectedImodel?.label}
        data-testid="atp-selected-imodel-btn"
      />
    </>
  );
}

function buildMenu(items?: IModelInfo[]) {
  if (!items)
    return undefined;

  return (close: () => void) => items.map((item) => {
    return (
      <MenuItem
        key={item.iModelId}
        value={item}
        size="default"
        onClick={(value: any) => {
          store.dispatch(imodelSelected(value));
          close();
        }}
      >
        {item.label}
      </MenuItem>
    )
  });
}